import { RouteObject } from 'react-router-dom';

import { ROUTES } from '@routes/routes.constants';

export const contractRoutes = [
  {
    path: ROUTES.CONTRACT_PAGE,
    lazy: async () => ({
      Component: (await import('./ContractPage')).ContractPage,
    }),
  },
  {
    path: ROUTES.CONTRACT_DOCUMENT,
    lazy: async () => ({
      Component: (await import('./ContractDocumentPage')).ContractDocumentPage,
    }),
  },
] satisfies RouteObject[];
